import { Card, Datepicker, ModalPopup, Search, SofturaTable } from "client/CommonComponents";
import excel from '../../../assets/images/Excel.svg'
import createNewAssessment from '../../../assets/images/Create New Assessment.svg'
import './MergerAcquisitionScan.scss'
import CreateEditNewScan from "./CreateEditNewScan";
import permissions, { ACCESS_DENIED, isAuthorized } from "client/utils/Permissions";
import UploadAssets from "./UploadAssets";

const UpdateDateFilterCell = (props: any) => {
    const { search, UpdatedDate, handleDateFilter, handleClearDateFilter, column } = props;
    return (
        <div className="date-filter-wrapper">
            <Datepicker
                placeholder="Select"
                value={UpdatedDate.current}
                onChangeDate={(date: any) =>
                    handleDateFilter(date, search, UpdatedDate, column?.key)
                }
             data-attribute="MergerAcquisitionScan_Default_Datepicker" />
            <i
                className="fa fa-times-circle-o"
                aria-hidden="true"
                onClick={() => handleClearDateFilter(search, UpdatedDate, column?.key)}
            ></i>
        </div>
    );
};

const MergerAcquisitionHome = (props: any) => {

    const {
        mergerandacquisitionscanColumnData,
        totalRecords,
        pagesCount,
        handleNameChange,
        handleDatesChange,
        values,
        isScanSavedFlag,
        setGridFilters,
        handleClearDateFilter,
        handleDateFilter,
        fetchAction,
        dealDate,
        scanStartDate,
        scanEndDate,
        createdDate,
        filters,
        paginationData,
        exportScans,
        onSearchGlobal,
        globalSearchBox,
        clearGlobalSearch,
        list,
        handleFileChange,
        onUploadAssetsClick,
        removeUploadedFile,
        isAssetsUploaded
    } = props

    const mergerandacquisitionscanColumn = [
        {
            key: "Action",
            title: "Action",
            width: 60,
            Cell: (row: any) => props?.CustomCell(row?.rowData),
            style: { textAlign: 'center' },
            id: 'action-column'
        },
        {
            key: "maScanName",
            title: "M&A Scan Name",
            width: 120,
            // Cell: (row: any) => {
            //     return (
            //         <>
            //           <a
            //             href={row?.rowData?.fileUrl}
            //             download
            //             target="_blank"
            //             className="order-link-id"
            //           >
            //             {row?.rowData?.maScanName}
            //           </a>
            //         </>
            //       );
            // },
            filterRowValue: filters?.maScanName ?? ''
        },
        {
            key: "dealDate",
            title: "Deal Date",
            width: 120,
            FilterCell: (updatedDateProps: any) => (
                <UpdateDateFilterCell
                    {...updatedDateProps}
                    UpdatedDate={dealDate}
                    handleDateFilter={handleDateFilter}
                    handleClearDateFilter={handleClearDateFilter}
                />
            ),
        },
        {
            key: "scanStartDate",
            title: "Scan Start Date",
            width: 120,
            FilterCell: (updatedDateProps: any) => {
                return <UpdateDateFilterCell
                    {...updatedDateProps}
                    UpdatedDate={scanStartDate}
                    handleDateFilter={handleDateFilter}
                    handleClearDateFilter={handleClearDateFilter}
                />;
            },
        },
        {
            key: "scanEndDate",
            title: "Scan End Date",
            width: 120,
            FilterCell: (updatedDateProps: any) => (
                <UpdateDateFilterCell
                    {...updatedDateProps}
                    UpdatedDate={scanEndDate}
                    handleDateFilter={handleDateFilter}
                    handleClearDateFilter={handleClearDateFilter}
                />
            ),
        },
        {
            key: "createdByName",
            title: "Created By",
            width: 120,
            filterRowValue: filters?.createdByName ?? ''
        },
        {
            key: "createdDate",
            title: "Created Date",
            width: 120,
            FilterCell: (updatedDateProps: any) => (
                <UpdateDateFilterCell
                    {...updatedDateProps}
                    UpdatedDate={createdDate}
                    handleDateFilter={handleDateFilter}
                    handleClearDateFilter={handleClearDateFilter}
                />
            )
        },
        {
            key: "status",
            title: "Assets Upload Status",
            width: 100,
            filterRowValue: filters?.status ?? ''
        },
        {
            key: "comments",
            title: "Comments",
            width: 120,
            filterRowValue: filters?.comments ?? ''
        }
    ]
    return (
        <div className='assessment-question CustomerMyOrder mt-1'>
            <div className='breadcrumb-toolbar'>
                <button
                    disabled={!(isAuthorized(permissions.CreateEditMAScan) || isAuthorized(permissions.ViewMAScanning))}
                    className='create-new-order-btn me-2'
                    title={isAuthorized(permissions.CreateEditMAScan) ? 'Create New M&A Scan' : ACCESS_DENIED}
                    onClick={props.CreateNewScanClick} data-attribute="MergerAcquisitionScan_Default_Button">
                    <img src={createNewAssessment} alt='btn-icon' />
                    <span>Create New M&A Scan</span>
                </button>
            </div>
            <Card data-attribute="MergerAcquisitionScan_Default_Card">
                <div className='create-new-order-container'>
                    <div className='grid-block pt-2'>
                        <div className='mb-1 top-section'>
                            <p className='assesst-question-head'>M&A Asset Inventory Admin Page</p>
                            <div className='clearfix mt-sm-2'>
                                <div className='pull-left searchblock ma-scan'>
                                    <Search
                                        placeholder='Search By M&A Name and Created by'
                                        className='searchTextbox'
                                        onSearch={(e?: any) => onSearchGlobal(e, true)}
                                        onBlur={(e?: any) => onSearchGlobal(e, false)}
                                        onChange={(e?: any) => onSearchGlobal(e, false)}
                                        value={globalSearchBox}
                                        onClear={clearGlobalSearch}
                                     data-attribute="MergerAcquisitionScan_Default_Searchbox" />
                                </div>
                                <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-0'>
                                    <button
                                        disabled={!isAuthorized(permissions.ViewMAScanning)}
                                        className='excel-section pointer'
                                        title={isAuthorized(permissions.ViewMAScanning) ? 'Export M&A Scans' : ACCESS_DENIED}
                                        onClick={exportScans} data-attribute="MergerAcquisitionScan_Default_Button_2">
                                        <img src={excel} alt='excel' />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className={`${mergerandacquisitionscanColumnData?.length != 0 ? "softura-table pe-0" : "softura-table paginationNav pe-0"}`}>
                            <SofturaTable
                                data={mergerandacquisitionscanColumnData ?? []}
                                columns={mergerandacquisitionscanColumn}
                                sort={true}
                                defaultPageSize={paginationData?.pageSize ?? 10}
                                pageSizes={[10, 20, 50]}
                                globalSearch={false}
                                filter={true}
                                getFilterValue={setGridFilters}
                                serverTotal={totalRecords}
                                fetchAction={fetchAction}
                                isServerSide={true}
                                pagesCount={pagesCount}
                                defaultPaginationPosition='Both'
                                fixedHeader={true}
                             data-attribute="MergerAcquisitionScan_Default_Grid" />
                        </div>
                    </div>
                </div>
            </Card>
            {
                props?.showCreateNewScanPopup ?
                    <ModalPopup
                        ModalPopupTitle={props?.showEditScanPopup ? 'EDIT M&A SCAN' : 'CREATE NEW M&A SCAN'}
                        ModalPopupType="medium"
                        closeModalPopup={props?.hidePopup}
                        ModalPopupName='createeditscan-popup'
                        ShowModalPopupFooter={true}
                        FooterSecondaryBtnTxt="Cancel"
                        FooterPrimaryBtnTxt={props?.showEditScanPopup ? 'Update' : 'Submit'}
                        FooterActionPrimaryyBtnTxt={props?.showEditScanPopup ? 'Upload Assets' : ''}
                        PrimaryBtnOnclick={props?.handleClickAdd}
                        SecondryBtnOnclick={props?.hidePopup}
                        PrimaryActionBtnOnclick={props?.uploadAssetBtnClick}
                        disablePrimaryActionBtn={!isAuthorized(permissions?.UploadMAScan)}
                        isFooterPrimaryBtnDisable={!isAuthorized(permissions.CreateEditMAScan)}
                     data-attribute="MergerAcquisitionScan_Default_ModalPopup">
                        <CreateEditNewScan
                            handleNameChange={handleNameChange}
                            handleDatesChange={handleDatesChange}
                            values={values}
                            isScanSavedFlag={isScanSavedFlag}
                        />
                    </ModalPopup> : ''
            }

            {
                props?.showUploadAssetsPopUp ?
                    <ModalPopup
                        ModalPopupTitle="UPLOAD ASSETS"
                        ModalPopupType="medium"
                        closeModalPopup={props.closeUploadAssetsModal}
                        ModalPopupName='upload-assets-popup'
                        ShowModalPopupFooter={true}
                        FooterSecondaryBtnTxt="Cancel"
                        FooterPrimaryBtnTxt="Save"
                        PrimaryBtnOnclick={onUploadAssetsClick}
                        SecondryBtnOnclick={props.closeUploadAssetsModal}
                        disablePrimaryActionBtn={!isAuthorized(permissions?.UploadMAScan)}
                     data-attribute="MergerAcquisitionScan_Default_ModalPopup_2">
                        <UploadAssets 
                            values={values}
                            list={list}
                            handleFileChange={handleFileChange}
                            removeUploadedFile={removeUploadedFile}
                            isAssetsUploaded={isAssetsUploaded}
                        />
                    </ModalPopup> : ''
            }
        </div>

    )
}

export default MergerAcquisitionHome;